// Mobile nav offcanvas (Bootstrap offcanvas-bottom-style behaviour,
// implemented natively — no Bootstrap dependency).
// Markup: resources/views/frontend/shared/header.blade.php
// Styles: resources/frontend/scss/layout/_offcanvas-menu.scss
import $ from 'jquery';

$(function () {
    const $openBtn = $('[data-offcanvas-open]');
    const $closeBtn = $('[data-offcanvas-close]');
    const $backdrop = $('[data-offcanvas-backdrop]');
    const $menu = $('[data-offcanvas-menu]');

    if (!$menu.length) {
        return;
    }

    const open = () => {
        $menu.addClass('offcanvas-menu--open');
        $backdrop.addClass('offcanvas-backdrop--visible');
        $('body').addClass('has-offcanvas-open');
        $openBtn.attr('aria-expanded', 'true');
        $closeBtn.trigger('focus');
    };

    const close = () => {
        $menu.removeClass('offcanvas-menu--open');
        $backdrop.removeClass('offcanvas-backdrop--visible');
        $('body').removeClass('has-offcanvas-open');
        $openBtn.attr('aria-expanded', 'false');
        $openBtn.trigger('focus');
    };

    $openBtn.on('click', open);
    $closeBtn.on('click', close);
    $backdrop.on('click', close);
    $menu.find('.nav-link').on('click', close);

    $(document).on('keydown', (event) => {
        if (event.key === 'Escape' && $menu.hasClass('offcanvas-menu--open')) {
            close();
        }
    });
});
